import React from "react";

const Banner = () => (
  <div className="container-fluid top-gap">
    <div className="informals-banner informals-splash">
      <div className="container text-center informals-title">
        <div className="row">
          <div className="col-xs-4 col-xs-offset-4">
            <a href={process.env.REACT_APP_AUDITOR_HOMEPAGE}
            aria-label="Auditor Home Page">
              <img
                src="/auditor_logo.png"
                height="125"
                className="img-responsive"
                alt="Auditor's Office Logo"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Banner;


